<template>
	<v-col>
		<base-material-card>
			<template #heading>
				<v-row class="d-s-flex">
					<v-col
						cols="12"
						:class="
							$vuetify.breakpoint.smAndDown
								? 'text-center display-2 font-weight-light'
								: 'display-2 font-weight-light'
						"
					>
						ניהול תוכניות
					</v-col>
					<v-col
						cols="12"
						:class="{
							'd-flex justify-center': $vuetify.breakpoint.smAndDown
						}"
					>
						<v-btn
							:to="{
								name: 'project-subscriptions',
								params: { id: project.id }
							}"
							class="ml-3"
						>
							Show Subscriptions
						</v-btn>
						<v-btn
							:to="{
								name: 'plan-create',
								params: { projectId: project.id }
							}"
						>
							Add Plan
						</v-btn>
					</v-col>
				</v-row>
			</template>
			<plans-display :plans="project.plans" />
		</base-material-card>
	</v-col>
</template>

<script>
import PlansDisplay from "../../components/PlansDisplay";
import { types } from "@/store/modules/Project.module";

export default {
	name: "Project",
	components: { PlansDisplay },
	data () {
		return {
			errors: {},
		};
	},
	computed: {
		hasPlans () {
			return this.project.plans && this.project.plans.length >= 1;
		},
		project () {
			return this.$store.state.ProjectModule.project;
		},
		createPlanLink () {
			return "/plans/create/" + this.project.id;
		},
	},
	async created () {
		await this.$store.dispatch(types.GET, this.$route.params.id);
	},
	methods: {},
};
</script>

<style scoped></style>
